"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CookieConsentBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="2074" id="cookieconsentbanner" className="bg-background text-foreground py-28 md:py-40 px-8 md:px-12 lg:px-20 relative overflow-hidden">
      {}
      <div className="max-w-4xl mx-auto flex items-center mb-16 md:mb-24">
        <div className="flex-1 h-px bg-border" />
        <div className="w-1.5 h-1.5 ml-2" style={{
        backgroundColor: "var(--primary)"
      }} />
      </div>

      <div ref={ref} className={`max-w-4xl mx-auto text-center relative transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
      transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
    }}>
        {}
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
          <span className="font-default font-light leading-none" style={{
          fontSize: "clamp(12rem, 28vw, 22rem)",
          color: "var(--foreground)",
          opacity: 0.05
        }}>
            03
          </span>
        </div>

        {}
        <div className="relative z-10 mb-10">
          <span className="font-default uppercase inline-block" style={{
          color: "var(--muted-foreground)",
          fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
          letterSpacing: "0.18em",
          fontWeight: 500
        }}>
            § 03 / PRIVACY POLICY
          </span>
        </div>

        {}
        <h2 className="font-default relative z-10 mb-8" style={{
        fontWeight: 600,
        fontSize: "clamp(2.125rem, 4.4vw, 3.875rem)",
        letterSpacing: "-0.025em",
        lineHeight: 1.02
      }}>
          We value your <em className="italic font-light">digital privacy</em>.
        </h2>

        {}
        <p className="relative z-10 max-w-2xl mx-auto mb-12" style={{
        color: "var(--muted-foreground)",
        fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
        lineHeight: 1.6,
        letterSpacing: "-0.005em"
      }}>
          VPNGENIX uses cookies to enhance your browsing experience, analyze site traffic, and ensure our security tools function optimally. By continuing to use our site, you agree to our use of cookies.
        </p>

        {}
        <div className="relative z-10 flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center">
          <Button asChild className="group h-auto rounded-lg px-7 py-4 font-default uppercase shadow-md hover:shadow-lg transition-all duration-200" style={{
          backgroundColor: "var(--primary)",
          color: "var(--primary-foreground)",
          fontSize: "0.875rem",
          letterSpacing: "0.04em",
          fontWeight: 600
        }}>
            <Link to="https://vpngenix.com/go/NordVPN" newTab>
              <span>Accept Cookies</span>
              <ArrowRight className="size-4 transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </Button>

          <Button asChild className="h-auto rounded-lg px-7 py-4 font-default uppercase shadow-md hover:shadow-lg transition-all duration-200 border" style={{
          backgroundColor: "transparent",
          color: "var(--foreground)",
          borderColor: "var(--border)",
          fontSize: "0.875rem",
          letterSpacing: "0.04em",
          fontWeight: 600
        }}>
            <Link to="/CybersecurityCyberGenixPage">
              <span>Learn More</span>
            </Link>
          </Button>
        </div>

        {}
        <div className="relative z-10 mt-10">
          <span className="font-default uppercase inline-block" style={{
          color: "var(--muted-foreground)",
          fontSize: "0.75rem",
          letterSpacing: "0.04em"
        }}>
            Secure Browsing — Always Protected
          </span>
        </div>
      </div>

      {}
      <div className="max-w-4xl mx-auto flex items-center mt-16 md:mt-24">
        <div className="flex-1 h-px bg-border" />
        <div className="w-1.5 h-1.5 ml-2" style={{
        backgroundColor: "var(--primary)"
      }} />
      </div>
    </section>;
}